import { z } from 'zod'

import DataSource from 'constants/sources/DataSource'

import { VoucherEventType, VoucherStatus, VoucherSyncStatus, VoucherType } from './voucherEnums'

export const voucherUserSchema = z.object({
  id: z.string(),
  display_name: z.string(),
  email: z.string(),
})

export type VoucherUser = z.infer<typeof voucherUserSchema>

export const voucherEventSchema = z.object({
  id: z.string(),
  // org: z.string(),
  // voucher: z.string(),
  user: voucherUserSchema,
  msg: z.string().nullish(),
  // user: z.string(), // Need to update this to voucherUserSchema
  type: z.nativeEnum(VoucherEventType),
  created_at: z.string(), // Need to update this to datetime
  comment: z.string().nullish(),
  details: z.record(z.string(), z.any()).nullish(),
})

const voucherTransactionDatasourceSchema = z.object({
  label: z.string(),
  source: z.nativeEnum(DataSource),
  source_id: z.string().nullish(),
})

export type VoucherEvent = z.infer<typeof voucherEventSchema>

export const voucherTransactionSchema = z.object({
  // IMPORTANT: `transaction_group_id` is the unique identifier used for edits and deletions
  transaction_group_id: z.string().nullish(),
  amount: z.string(),
  asset: z.string().nullish(), // Need to update this to asset
  certifier_description: z.string().nullish(),
  contract_address: z.string().nullish(),
  created_at: z.string().datetime(),
  datasource: voucherTransactionDatasourceSchema,
  date: z.string(), // Need to update this to datetime
  fee_amount: z.string().nullish(),
  fee_fiat: z.string().nullish(),
  fiat: z.string().nullish(),
  id: z.string().nullish(),
  obligation: z.string().nullish(),
  officer: z.string().nullish(),
  org: z.string().nullish(),
  purpose: z.string().nullish(),
  transaction_id: z.string().nullish(),
  voucher: z.string().nullish(),
})
export type VoucherTransaction = z.infer<typeof voucherTransactionSchema>

export const voucherSchema = z.object({
  id: z.string(),
  voucher_id: z.string().nullish(),
  organization: z.string(),
  preparer: voucherUserSchema,
  title: z.string(),
  type: z.nativeEnum(VoucherType).nullish(),
  description: z.string().nullish(),
  status: z.nativeEnum(VoucherStatus),
  sync_status: z.nativeEnum(VoucherSyncStatus).nullish(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
  directorate: z.string().nullish(),
  office: z.string().nullish(),
  vendor_code: z.string().nullish(),
  responsible_officer: voucherUserSchema.nullish(),
  auditor: voucherUserSchema.nullish(),
  approver: voucherUserSchema.nullish(),
  certifier: voucherUserSchema.nullish(),
  voucher_events: z.array(voucherEventSchema).nullish(),
  voucher_transactions: z.array(voucherTransactionSchema).nullish(),
  total_value: z.string(),
})

export type Voucher = z.infer<typeof voucherSchema>
